import { DashboardCreate } from "../models/DashboardCreate";
import axiosApi from "../../../../components/Api/Axios";
import BackendServices from "../../../../components/Api/BackendService";

export default (dashboard: DashboardCreate, id: string) =>
  axiosApi.put(
    `${BackendServices.DASHBOARD_SERVICE.DASHBOARD}/${id}`,
    dashboard
  );
